import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: {
    id: 'page.title',
    defaultMessage: 'Babylon Signup',
  },
  next: {
    id: 'page.cta.next',
    defaultMessage: 'Next',
  },
  closeButtonText: {
    id: 'modal.closebuttontext',
    defaultMessage: 'Close',
  },
  backButtonText: {
    id: 'modal.backbuttontext',
    defaultMessage: 'Back',
  },
  negativeFeedback: {
    id: 'appmessage.error',
    defaultMessage: 'Oops, something went wrong.',
  },
  positiveFeedback: {
    id: 'appmessage.positive',
    defaultMessage: 'Operation Successful!',
  },
  apiRateLimitExceededFeedback: {
    id: 'appmessage.apiratelimitexceeded',
    defaultMessage: 'Unable to signup or login. Please try again later.',
  },
})
